import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./TopPerfomance.module.css";
import { R_PER_PAGE } from "../../../../../../labels";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../../../axios";
import DatePickerSample from "../../../../DatePicker";
import { Chip, Paper } from "@mui/material";
import styled from "styled-components";
import moment from "moment";
function TopPerfomanceAnswerSheet() {
  let page = R_PER_PAGE;
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [sortOrder, setSortOrder] = useState("");
  const [isOpen, setIsOpen] = useState({
    status: false,
    exam_date: false,
    upload_date: false,
    test_topic_name: false,
    subject: false,
    mediumStatus: false,
  });
  const txtEvDuedate = useRef(null);
  const txtEvTDuedate = useRef(null);
  const [assignStatus, assignSetStatus] = useState([]);
  const [mediumStatus, setMediumStatus] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const filterRef = useRef(null);
  const navigate = useNavigate();
  // Handle change event
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "Tamil" || name === "English") {
      if (checked) {
        setMediumStatus([
          ...mediumStatus,
          { id: value, name: name, type: "mediumStatus" },
        ]);
      } else {
        setMediumStatus(mediumStatus.filter((item) => item.id !== value));
      }
    }
  };

  //chips overall clear button
  const handleAllClear = (nameD) => {
    if (nameD === "dayRange") {
      setAppOn([]);
      setAppOn_on([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setUpdateChipData([]);
    }
    setMediumStatus([]);
    setUpdateChipData([]);
    setData([]);
  };
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = [...data].sort((a, b) => {
      // Convert both strings to lowercase to ensure case-insensitive comparison
      let aValue = a[sortKey]?.toString().toLowerCase();
      let bValue = b[sortKey]?.toString().toLowerCase();

      if (aValue < bValue) {
        return order === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === "asc" ? 1 : -1;
      }
      if (aValue == bValue) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setData(sortedList);
  };
  // mobile tooltip
  let pressTimer;
  document.querySelectorAll(".tooltip-container").forEach((el) => {
    el.addEventListener("touchstart", function () {
      pressTimer = setTimeout(() => {
        this.classList.add("active");
      }, 500); // Long press duration
    });

    el.addEventListener("touchend", function () {
      clearTimeout(pressTimer);
      this.classList.remove("active");
    });
  });
  useEffect(() => {
    loadChipdata();
  }, []);
  useEffect(() => {
    if (updateChipData.length > 0) {
      topPerformerList();
    }
  }, [updateChipData]);
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        status: !prevState.status,
        method_of_test: false,
      }));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        mediumStatus: !prevState.mediumStatus,
      }));
      setMediumStatus(
        updateChipData.filter((ui) => ui.type === "mediumStatus")
      );
    } else if (boxName === "exam_date") {
      setIsOpen((prevState) => ({
        exam_date: !prevState.exam_date,
        method_of_test: false,
      }));
    } else if (boxName === "upload_date") {
      setIsOpen((prevState) => ({
        upload_date: !prevState.upload_date,
        method_of_test: false,
      }));
    }
  };
  let filterApplyed = [];
  let filterUploadApplyed = [];
  let filterMediumStatus = [];
  function updateStateData() {
    filterMediumStatus = mediumStatus;
    filterApplyed = appOn;
    filterUploadApplyed = appOn_on;
  }
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appData_on, setAppData_on] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appOn, setAppOn] = useState([]);
  const [appOn_on, setAppOn_on] = useState([]);
  const filterRefUploadDate = useRef(null);
  const filterRefMedium = useRef(null);
  const handleClickOutside = (event) => {
    const isChipData = event.target.closest(".paperil_global");
    const isCheckbox = event.target.closest('input[type="checkbox"]');
    // Check if the click target is the "Apply Filter" button
    const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");

    if (
      filterRef.current &&
      !filterRef.current.contains(event.target) &&
      !isCheckbox &&
      !isApplyFilterButton &&
      !isChipData
    ) {
      if (!isOpen.exam_date && appOn.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, exam_date: false }));
      } else if (!isOpen.exam_date && appOn.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, exam_date: false }));
      }
    }
    if (
      filterRefUploadDate.current &&
      !filterRefUploadDate.current.contains(event.target) &&
      !isCheckbox &&
      !isApplyFilterButton &&
      !isChipData
    ) {
      if (!isOpen.upload_date && appOn_on.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, upload_date: false }));
      } else if (!isOpen.upload_date && appOn_on.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, upload_date: false }));
      }
    }
    if (
      filterRefMedium.current &&
      !filterRefMedium.current.contains(event.target) &&
      !isCheckbox &&
      !isApplyFilterButton &&
      !isChipData
    ) {
      if (!isOpen.mediumStatus) {
        setIsOpen((prevState) => ({ ...prevState, mediumStatus: false }));
      } else if (!isOpen.mediumStatus) {
        setIsOpen((prevState) => ({ ...prevState, mediumStatus: false }));
      }
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: dateFilter }));
      const from = name === "FDate" ? dateFilter : appData.FDate;
      const to = name === "TDate" ? dateFilter : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData_on((prevState) => ({ ...prevState, [name]: dateFilter }));
      const from = name === "FDate" ? dateFilter : appData_on.FDate;
      const to = name === "TDate" ? dateFilter : appData_on.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn_on([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dayRange_on",
        },
      ]);
    }
  };
  const handleRadioChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData.FDate;
      const to = name === "TDate" ? value : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: from !== "" ? moment(from).format("YYYY-MM-DD") : "",
          edate: to !== "" ? moment(to).format("YYYY-MM-DD") : "",
          type: "dateRange",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppData((prevState) => ({ ...prevState, [name]: value }));
      }
      if (value === "Today") {
        const today = new Date();
        setAppOn([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      }
    }
  };
  const handleAppliedOn_on = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData_on((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData_on.FDate;
      const to = name === "TDate" ? value : appData_on.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn_on([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange_on",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppData_on((prevState) => ({ ...prevState, [name]: value }));
      }
      // else {
      //   setAppOn(appOn.filter((item) => item !== value));
      // }
      if (value === "Today") {
        const today = new Date();
        setAppOn_on([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn_on([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn_on([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn_on([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn_on([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn_on([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange_on",
          },
        ]);
      }
    }
  };

  const handleClear = (name) => {
    if (name === "medium") {
      setMediumStatus([]);
      filterMediumStatus = [];
      setData(data);
    } else if (name === "exam_date") {
      setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
    } else if (name === "upload_date") {
      setAppOn_on([]);
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
    }
  };
  function loadChipdata() {
    let tempArr = [];
    filterMediumStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterUploadApplyed.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      const filtered = data.filter((course) =>
        assignStatus.some((s) => s.id === String(course.que_status))
      );
      // Update the filteredData state
      setData(filtered);
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        mediumStatus: false,
      });
    } else if (name === "exam_date") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        exam_date: false,
      });
    } else if (name === "upload_date") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        upload_date: false,
      });
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "dateRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      setAppOn_on([]);
    } else if (chipToDelete.type === "mediumStatus") {
      setMediumStatus(
        mediumStatus.filter((item) => item.id !== String(chipToDelete.id))
      );
      filterMediumStatus = mediumStatus.filter(
        (item) => item.id !== String(chipToDelete.id)
      );
    }
    setIsOpen(false);
    loadChipdata();
  };

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);
  useEffect(() => {
    filterUploadApplyed = appOn_on;
  }, [appData_on]);
  useEffect(() => {
    filterMediumStatus = mediumStatus;
  }, [mediumStatus]);
  useEffect(() => {
    topPerformerList();
  }, [updateChipData]);

  const topPerformerList = () => {
    setLoading(true);
    let typeMediumStatus = [];
    mediumStatus.map((obj) => {
      typeMediumStatus.push(obj.id);
    });
    AxiosInstance.post("api/test/descriptive/topper_list", {
      medium:
        typeMediumStatus.length > 0 && typeMediumStatus.length < 2
          ? typeMediumStatus[0]
          : "",
      subject: "",
      test_topic: "",
      exam_start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      exam_end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      upload_start_date:
        appOn_on.length > 0 ? appOn_on[0].fdate + " 00:00:00" : "",
      upload_end_date:
        appOn_on.length > 0 ? appOn_on[0].edate + " 23:59:00" : "",
    })
      .then((res) => {
        setData(res.data?.data);
      })
      .then((res) => {
        setData(res.data?.data);
      })
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((error) => {
        setLoading(false);
        return error;
      });
  };
  useEffect(() => {
    topPerformerList();
  }, [updateChipData]);

  const handleNavigate = (navigateId) => {
    navigate(`/ViewAnswerSheet/${navigateId}`);
  };
  // total table data  with pages
  const totalPages = Math.ceil(data?.length / rowsPerPage);
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setData([]);
    topPerformerList();
  };
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = data ? data.slice(start, end) : [];
  const ListItem = styled("li")(({ themes }) => ({
    margin: themes?.spacing(1.5),
  }));
  const totalRecords = data?.length || 0;
  return (
    <>
      <div
        className={`${styles.topPerformAnsMain} global_container container-fluid BathHeader`}
      >
        <div className="row">
          <div className=" col-md-6 col-12 ">
            <h2 className="TitleHeader "> Top Performer Answer Sheets</h2>
          </div>

          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link to={"/TestList"} className="secondaryButton ">
                  Back to Test
                </Link>
              </li>

              <li class="ListBtnItems">
                <Link className="primaryButton " to={"/UploadAnswerSheet"}>
                  <span className="material-icons align-middle text-white">
                    file_upload
                  </span>
                  Upload Answer Sheet
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="row p-0 m-1">
          {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
            <div className="row mt-3">
              <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
                <Paper
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    listStyle: "none",
                    p: 0.5,
                    m: 0,
                  }}
                  component="ul"
                >
                  {updateChipData
                    .filter((kl) => kl.name !== "ActiveTab")
                    .map((data, index) => {
                      let icon;
                      let key = "" + data.name;
                      return (
                        <ListItem key={data}>
                          <Chip
                            icon={icon}
                            label={key}
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}

                  <ListItem className="clearAll_list">
                    <a
                      className="clearAll_listItem"
                      href="#"
                      onClick={() => handleAllClear("dayRange")}
                    >
                      Clear All Filters
                    </a>
                  </ListItem>
                </Paper>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <div className="col-md-12 mt-3 tableMinHeight table-responsive px-0">
            <table className={`table`} id="tableListHeader">
              <thead>
                <tr>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "student_name")}
                    >
                      Student Name
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "student_name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "over_all_rank")}
                    >
                      Overall Rank
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "over_all_rank")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th "
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      {" "}
                      Batch Name
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th "
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      {" "}
                      Exam Name
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "exam_name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th" ref={filterRefMedium}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "medium")}
                    >
                      Medium of Instruction
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "medium")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        mediumStatus.length > 0 ? styles.active_icons : ""
                      } ${isOpen.mediumStatus ? styles.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "medium")}
                    >
                      filter_list
                    </span>

                    {isOpen.mediumStatus === true && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                type="checkbox"
                                className="ListCheckbox"
                                name="Tamil"
                                value="0"
                                id="Tamil"
                                checked={mediumStatus.some(
                                  (element) => element.id === "0"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="form-check-label filterChipText bg-pink"
                                htmlFor="Tamil"
                              >
                                Tamil
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                type="checkbox"
                                className="ListCheckbox"
                                name="English"
                                value="1"
                                id="English"
                                checked={mediumStatus.some(
                                  (element) => element.id === "1"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="bg-green filterChipText form-check-label"
                                htmlFor="English"
                              >
                                English
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("medium")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleApplyFilter("medium")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  <th id="th" ref={filterRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      Subject
                    </span>
                  </th>
                  <th id="th" ref={filterRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "test_topic_name")}
                    >
                      Test Topic
                    </span>
                  </th>
                  <th id="th" ref={filterRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "exam_date")}
                    >
                      Date of Exam
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "exam_date")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        appOn.length > 0 ? styles.active_icons : ""
                      } ${isOpen.exam_date ? styles.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "exam_date")}
                    >
                      filter_list
                    </span>
                    {isOpen.exam_date === true && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul class="ulFilterListData mb-2">
                            <li class="filterListData ">
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value me-1"
                              >
                                From Date
                              </label>
                              <DatePickerSample
                                IconInput={"LI_filterIocnBoxInput"}
                                class={"LI_FilterInputs"}
                                name={"FDate"}
                                minDate={
                                  new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  )
                                } // Minimum date is tomorrow
                                handleChange={handleChangeDate}
                                fieldInput={appData.FDate}
                                txtAdMDob={txtEvDuedate}
                              />
                            </li>
                            <li class="filterListData">
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value me-4"
                              >
                                To Date
                              </label>
                              <DatePickerSample
                                class={"LI_FilterInputs"}
                                IconInput={"LI_filterIocnBoxInput"}
                                name={"TDate"}
                                minDate={
                                  new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  )
                                } // Minimum date is tomorrow
                                handleChange={handleChangeDate}
                                fieldInput={appData.TDate}
                                txtAdMDob={txtEvTDuedate}
                              />
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData borderWidth"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput    col-6">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                id="Today"
                                name="Days"
                                value="Today"
                                checked={appData.Days === "Today"}
                                onChange={handleRadioChange}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value "
                                for="Today"
                              >
                                Today
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Yesterday"
                                id="Yesterday"
                                checked={appData.Days === "Yesterday"}
                                onChange={handleRadioChange}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="Yesterday"
                              >
                                Yesterday
                              </label>
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Tweek"
                                id="Tweek"
                                checked={appData.Days === "Tweek"}
                                onChange={handleRadioChange}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="Tweek"
                              >
                                This Week
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Lweek"
                                id="lastWeek"
                                onChange={handleRadioChange}
                                checked={appData.Days === "Lweek"}
                              />

                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="lastWeek"
                              >
                                Last Week
                              </label>
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Tmonth"
                                id="month"
                                onChange={handleRadioChange}
                                checked={appData.Days === "Tmonth"}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="month"
                              >
                                This Month
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Lmonth"
                                id="lastMonth"
                                checked={appData.Days === "Lmonth"}
                                onChange={handleRadioChange}
                              />

                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="lastMonth"
                              >
                                Last Month
                              </label>
                            </li>
                          </ul>
                        </div>

                        <div className=" borderWidth row">
                          <ul className="List-Button">
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleClear("exam_date")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("exam_date")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  <th id="th" ref={filterRefUploadDate}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "upload_date")}
                    >
                      Uploaded Date & Time
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "upload_date")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        appOn_on.length > 0 ? styles.active_icons : ""
                      } ${isOpen.upload_date ? styles.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "upload_date")}
                    >
                      filter_list
                    </span>

                    {isOpen.upload_date === true && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul class="ulFilterListData mb-2">
                            <li class="filterListData ">
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value me-1"
                              >
                                From Date
                              </label>
                              <DatePickerSample
                                IconInput={"LI_filterIocnBoxInput"}
                                class={"LI_FilterInputs"}
                                name={"FDate"}
                                minDate={
                                  new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  )
                                } // Minimum date is tomorrow
                                handleChange={handleChangeDate_app}
                                fieldInput={appData_on.FDate}
                                txtAdMDob={txtEvDuedate}
                              />
                            </li>
                            <li class="filterListData">
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value me-4"
                              >
                                To Date
                              </label>
                              <DatePickerSample
                                class={"LI_FilterInputs"}
                                IconInput={"LI_filterIocnBoxInput"}
                                name={"TDate"}
                                minDate={
                                  new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  )
                                } // Minimum date is tomorrow
                                handleChange={handleChangeDate_app}
                                fieldInput={appData_on.TDate}
                                txtAdMDob={txtEvTDuedate}
                              />
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData borderWidth"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput    col-6">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                id="Today"
                                name="Days"
                                value="Today"
                                checked={appData_on.Days === "Today"}
                                onChange={handleAppliedOn_on}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value "
                                for="Today"
                              >
                                Today
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Yesterday"
                                id="Yesterday"
                                checked={appData_on.Days === "Yesterday"}
                                onChange={handleAppliedOn_on}
                              />

                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="Yesterday"
                              >
                                Yesterday
                              </label>
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Tweek"
                                id="Tweek"
                                checked={appData_on.Days === "Tweek"}
                                onChange={handleAppliedOn_on}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="Tweek"
                              >
                                This Week
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Lweek"
                                id="lastWeek"
                                onChange={handleAppliedOn_on}
                                checked={appData_on.Days === "Lweek"}
                              />

                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="lastWeek"
                              >
                                Last Week
                              </label>
                            </li>
                          </ul>
                          <ul
                            class="ulFilterListData"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Tmonth"
                                id="month"
                                onChange={handleAppliedOn_on}
                                checked={appData_on.Days === "Tmonth"}
                              />
                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="month"
                              >
                                This Month
                              </label>
                            </li>
                            <li class="filterListData filterRadioInput col-6 ">
                              <input
                                type="radio"
                                className="ListCheckbox"
                                name="Days"
                                value="Lmonth"
                                id="lastMonth"
                                checked={appData_on.Days === "Lmonth"}
                                onChange={handleAppliedOn_on}
                              />

                              <label
                                htmlFor="startDate"
                                class="form-label confirm_value"
                                for="lastMonth"
                              >
                                Last Month
                              </label>
                            </li>
                          </ul>
                        </div>

                        <div className=" borderWidth row">
                          <ul className="List-Button">
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleClear("upload_date")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("upload_date")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "applicable_batch")}
                    >
                      Applicable Batches
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "applicable_batch")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id="th">
                    <span className="textHead_th"> Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData && currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr className={styles.rowHover} key={index}>
                      <td id={`${styles.td}`}>{course.student_name}</td>
                      <td id={`${styles.td}`}>{course.over_all_rank}</td>
                      <td title={course.batch_name} id={`${styles.td}`}>
                        {course.batch_name}
                      </td>
                      <td title={course.exam_name} id={`${styles.td}`}>
                        {course.exam_name}
                      </td>

                      {course.medium === 0 && (
                        <td id={`${styles.td}`}>
                          <span className="PinkText">Tamil</span>
                        </td>
                      )}
                      {course.medium === 1 && (
                        <td id={`${styles.td}`}>
                          <span className="GreenTexts">English</span>
                        </td>
                      )}
                      <td id={`${styles.td} tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subject
                            .map((item) => item.subject)
                            .join(", ")}
                        >
                          {course.subject
                            .map((item) => item.subject)
                            .join(", ")}
                        </span>
                      </td>
                      <td id={`${styles.td} tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subject
                            .map((item) =>
                              item.test_topics
                                .map((testTopic) => testTopic.test_topic_name)
                                .join(", ")
                            )
                            .join(", ")}
                        >
                          {course.subject
                            .map((item) =>
                              item.test_topics
                                .map((testTopic) => testTopic.test_topic_name)
                                .join(", ")
                            )
                            .join(", ")}
                        </span>
                      </td>

                      <td id={`${styles.td}`}>
                        {course.exam_date
                          ? moment(course.exam_date).format("DD/MM/YYYY")
                          : "_"}
                      </td>
                      <td id={`${styles.td}`}>
                        {course.upload_date
                          ? moment(course.upload_date).format("DD/MM/YYYY")
                          : "_"}
                      </td>

                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.applicable_batch
                            .map((item) => item)
                            .join(", ")}
                        >
                          {course.applicable_batch
                            .map((item) => item)
                            .join(", ")}
                        </span>
                      </td>
                      <td id={`${styles.td}`}>
                        <a
                          href={`javascript:void(0)`}
                          onClick={() => handleNavigate(course.id)}
                          className={`${styles.button}`}
                        >
                          <span className="material-icons">visibility</span>
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              totalRecords > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0
            }
            endPage={
              totalRecords > 0
                ? Math.min(currentPage * rowsPerPage, totalRecords)
                : 0
            }
            totalRecords={totalRecords}
            handlePrev={() =>
              totalRecords > 0 &&
              setCurrentPage((prev) => Math.max(prev - 1, 1))
            }
            currentPrevPage={currentPage === 1 || totalRecords === 0}
            prevButton={`${styles.prev_buttonCentreSup} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() =>
              totalRecords > 0 &&
              setCurrentPage((prev) =>
                Math.min(prev + 1, Math.ceil(totalRecords / rowsPerPage))
              )
            }
            currentNextPage={
              currentPage === Math.ceil(totalRecords / rowsPerPage) ||
              totalRecords === 0
            }
          />
        </div>
      </div>
    </>
  );
}
export default TopPerfomanceAnswerSheet;
